<template>
    <div id="app">
            <Tr069 />

    </div>
</template>

<script>
import Tr069 from '@/views/advanceSetup/cwmp'
export default {
    components:{
        Tr069
    }
}
</script>


<style>
#app{
    width: 100%;
    height: 100%;
}
</style>
